<template>
	<div>
		<policy-stakeholders :types="types" />
	</div>
</template>

<script>
import PolicyStakeholders from "../PolicyStakeholders"
export default {
	components: { PolicyStakeholders },

	data() {
		return {
			types: [
				{ name: "Company", value: "company" },
				{ name: "Business Unit", value: "businessUnit" },
				{ name: "Policyholder", value: "policyHolder" },
				{ name: "Insured", value: "insured" },
				{ name: "Mother Company", value: "motherCompany" },
				{ name: "Contact Name", value: "contactName" },
				{ name: "Underwriter", value: "underwriter" },
				{ name: "London Broker", value: "londonBroker" },
				{ name: "Broker", value: "broker" },
				{ name: "Handled By", value: "handledBy" },
				{ name: "Signed By", value: "signedBy" },
				{ name: "Agency", value: "agency" },
				{
					name: "Third Party Referral - Company",
					value: "thirdPartyReferralCompany"
				},
				{
					name: "Third Party Referral - Individual",
					value: "thirdPartyReferralIndividual"
				},
				{ name: "Salesman", value: "salesman" },
				{ name: "Local Sub-Producer", value: "localSubProducer" },
				{ name: "Coverholder", value: "coverholder" },
				{ name: "Loss Adjuster", value: "lossAdjuster" },
				{ name: "Solicitor", value: "solicitor" },
				{ name: "Recovery From Party", value: "recoveryFromParty" }
			]
		}
	}
}
</script>